import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { BaseQuestionAiChangePreviewComponent } from '../../../bases';
import { useMemo } from 'react';
import { SingleChoiceAiChangeStrategyFactory } from './strategies';
import styled from '@xstyled/styled-components';
import { getSize } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledQuestionTitle = styled.label(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 700;\n  color: #64748b;\n  line-height: 1rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n"])), getSize('typo12'));
export var SingleChoiceAiChangePreviewComponent = function SingleChoiceAiChangePreviewComponent(_ref) {
  var states = _ref.states,
      actions = _ref.actions;
  var before = states.before,
      after = states.after,
      changeType = states.changeType,
      labels = states.labels;
  var strategy = useMemo(function () {
    return SingleChoiceAiChangeStrategyFactory.create({
      changeType: changeType,
      before: before,
      after: after,
      label: {
        badgeNew: labels.badgeNew,
        badgeEdit: labels.badgeEdit,
        badgeDelete: labels.badgeDelete
      }
    });
  }, [changeType, before, after, labels.badgeNew, labels.badgeEdit, labels.badgeDelete]);
  return /*#__PURE__*/_jsxs(BaseQuestionAiChangePreviewComponent, {
    states: _objectSpread(_objectSpread({}, states), {}, {
      strategy: strategy
    }),
    actions: actions,
    children: [/*#__PURE__*/_jsx(StyledQuestionTitle, {
      children: labels.answers
    }), strategy.renderAnswers()]
  });
};